import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import UserAccount from './UserAccount';
import {
  getUserAccountData,
  addAccount,
  editAccount,
  addPusername,
  addNickname,
  addEmailuser,
  addMobilename,
  getUserAcc,
  resetUsers,
  resetPassTo
} from 'src/actions/userAccountAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
// import { handleCloseAlert } from 'src/actions/errorAction';
// import { handleCloseAlert } from 'src/actions/errorAction';
// import { push } from 'react-router-redux';

export const mapStateToProps = (state: AppState) => {
  return {
    userAccounts: state.userAccountData.userAccountdata,
    pusername: state.userAccountData.addpusername,
    nickname: state.userAccountData.addnickname,
    emailuser: state.userAccountData.addemail,
    mobileuser: state.userAccountData.addmobile,

    // errorMessage: state.errorState.errorMessage,
    // errorBar: state.errorState.errorBar,
    // successMessage: state.errorState.successMessage,
    // successBar: state.errorState.successBar,

  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      // dispatch(getUserAccountData);
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
      dispatch(getUserAccountData);
    },
    addAccount: () => {
      dispatch(addAccount());
    },
    getUserAcc: (username: string) => {
      dispatch(getUserAcc(username));
    },
    editAccount: () => {
      dispatch(editAccount());
    },
    addPusername: (pusername: string) => {
      dispatch(addPusername(pusername));
    },
    addNickname: (nickname: string) => {
      dispatch(addNickname(nickname));
    },
    addEmailuser: (emailuser: string) => {
      dispatch(addEmailuser(emailuser));
    },
    addMobileuser: (mobileuser: string) => {
      dispatch(addMobilename(mobileuser));
    },
    resetPassword: (username: string) => {
      dispatch(resetPassTo(username));
    },
    // handleClose: () => {
    //   dispatch(handleCloseAlert);
    // },
    resetUsers: () => {
      dispatch(resetUsers());
    }
  };
};

const UserAccountContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserAccount);

export default UserAccountContainer;



// WEBPACK FOOTER //
// ./src/components/userAccount/UserAccountContainer.tsx